<template>
  <div id="app" v-cloak>
    <SVGs />

    <MapContainer />

    <GeoDataDisplay
      :currentGeolocation="currentGeolocation"
      :zoomLevelCurrent="zoomLevelCurrent"
    />

    <router-link to="/">
      <header>
        <h1>Geo Mover<span>{{ appVersion }}</span></h1>
        <p>Your private GPS tracker</p>
      </header>
    </router-link>

    <div class="toggle-follow-centered-view" v-if="recording">
      <svg
        class="w-7 h-7 select-none  rounded"
        :class="{ 'bg-gray-200 text-gray-600': !lockViewToCenter, 'bg-red-600 text-red-100': lockViewToCenter }"
        role="button"
        aria-label="Put map in center of view while recording"
        @click="toggleFollowCenteredView">
        <use xlink:href="#centerViewOff" v-if="!lockViewToCenter"/>
        <use xlink:href="#centerViewOn" v-if="lockViewToCenter"/>
       </svg>
    </div>

    <!-- v-on:after-enter="afterEnter" -->
    <transition name="fade" mode="out-in" appear v-if="setupFinished">
      <router-view :key="$route.params.id"></router-view>
    </transition>

    <Sidebar />

    <global-modal />

    <!-- ONLY DEBUGGING -->
    <DebuggingTextArea />

    <div v-if="0 === 1" class="[ KEEP_FOR_TESTS_ONLY ] w-104 h-120 absolute left-3 top-80 bg-white rounded p-6 text-pink-900 z-120">
      {{ currentGeolocation }}
    </div>

  </div>
</template>

<script>
import GeoMoverDB from '@/db/indexeddb'
import { version } from '../package.json'
import { mapGetters } from 'vuex'
import { EventBus } from '@/eventBus'

export default {
  components: {
    SVGs: () => import('@/components/SVGs'),
    Sidebar: () => import('@/views/Sidebar/Sidebar'),
    MapContainer: () => import('@/components/MapContainer'),
    DebuggingTextArea: () => import('@/components/DebuggingTextArea'),
    GeoDataDisplay: () => import('@/components/GeoDataDisplay')
  },
  data () {
    return {
      appVersion: version,
      setupFinished: false
    }
  },
  computed: {
    ...mapGetters({
      dbReady: 'settings/getDbReady',
      zoomLevelCurrent: 'settings/getZoomLevelCurrent',
      currentGeolocation: 'geolocation/getCurrentGeolocation',
      recording: 'newActivity/getRecording'
    }),
    lockViewToCenter: {
      get () { return this.$store.getters['geolocation/getLockViewToCenter'] },
      set (bool) { this.$store.dispatch('geolocation/setLockViewToCenter', bool) }
    }
  },
  async beforeCreate () {
    // this.$l.log('App: methods', 'beforeCreate invoked: initialize GeoMoberDB')
    const dbInitialised = await GeoMoverDB.init()

    this.$store.dispatch('settings/setDbReady', dbInitialised)
    this.$store.dispatch('settings/initSettings')

    // This var is needed, so the first component is loaded only AFTER the db
    // is completely setup. The first component to be loaded is "NewActivity"
    // and it calls "initialGeolocationPermissionCheck" ...
    // See transition tag
    this.setupFinished = true
  },
  methods: {
    toggleFollowCenteredView () {
      this.lockViewToCenter = !this.lockViewToCenter
      EventBus.$emit('lockViewToCenterWhenRecording')
    },
    afterEnter: function (el) {
      // how to have this per-route
      this.$l.debug('App', 'afterEnter invoked; Route entered', '')
    }
  }
}
</script>

<style scoped lang="postcss">
header {
  @apply absolute left-2 top-2 z-50 px-2 py-1 bg-pink-200 rounded bg-opacity-70 shadow-lg select-none
}
header h1 {
  @apply text-2xl font-bold text-pink-800
}
header h1 span {
  @apply ml-3 text-xs font-medium tracking-widest
}
header p {
  @apply text-pink-800 tracking-wider uppercase text-xs
}

.toggle-follow-centered-view {
  @apply absolute ;
  @apply select-none cursor-pointer z-10;
  @apply left-3 top-64 p-0 flex items-center justify-center;
}

.toggle-follow-centered-view:hover {
  @apply transition bg-opacity-90;
}
</style>
